
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Accueil from "./pages/Accueil";
import Layout from "./components/Layout";
import Settings from "./pages/Settings";
import { useEffect } from "react";
import Ventes from "./pages/Ventes";
import Profil from "./pages/users/Profil";
import Product from "./pages/products/Product";
import Plat from "./pages/plats/Plat";
import Reservation from "./pages/Reservation/Reservation";
import Client from "./pages/customer/Client";
import Invoice from "./pages/recu/Invoice";
import Categorie from "./pages/Settings/Categorie";
import User from "./pages/Settings/User";
import Table from "./pages/Settings/Table";
import Fournisseur from "./pages/Settings/Fournisseur";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import CommonCheckAuth from "./components/common/CommonCheckAuth";
import { useDispatch, useSelector } from "react-redux";
import { checkAuth } from "./store/authSlice";
import AuthLogin from "./pages/auth/AuthLogin";
import AuthLayout from "./pages/auth/AuthLayout";
import AuthRegister from "./pages/auth/AuthRegister";
import PosSystem from "./pages/PosSystem";

function App() {

  const { user, isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const location = window.location.pathname;


  useEffect(() => {
    document.title = "MEZA NGEMA POS SYSTEM";


    // vérifier si un utilisateur est connecté
    const token = localStorage.getItem("token");
    // console.log("Token:", token);

    if (token) {
      dispatch(checkAuth());
    } else {
      dispatch({ type: "auth/checkAuth/rejected" }); // Pour éviter un chargement infini si pas de token
    }

    // Ajoute les scripts dynamiquement
    const scriptUrls = ["assets/js/scripts.js"]; // Assurez-vous du chemin correct

    const addScript = (scriptUrls) => {
      scriptUrls.forEach((src) => {
        if (!Array.from(document.scripts).some(script => script.src.includes(src))) {
          const script = document.createElement("script");
          script.src = src;
          script.async = false;
          script.setAttribute("data-dynamic", "true");
          script.onerror = () => {
            console.error(`Failed to load script: ${src}`);
          };
          document.body.appendChild(script); // Ajoute le script au DOM
        }
      });
    };

    if (!location.includes("/login") || !location.includes("/register" ||
      !location.includes("/reset-password" || !location.includes("/forgot-password")))) {
      addScript(scriptUrls);
    }

    return () => {
      // Supprime les scripts ajoutés dynamiquement
      scriptUrls.forEach((src) => {
        const scripts = Array.from(document.scripts).find(s => s.src.includes(src));
        if (scripts) {
          document.body.removeChild(scripts);
        }
      });
    };

  }, [dispatch, location]);

  // Affichage de l'indicateur de chargement
  if (isAuthenticated) {
    if (isLoading) {
      return (
        <div className="flex justify-center items-center h-screen">
          <div className="border-gray-900 border-t-2 border-b-2 rounded-full w-32 h-32 animate-spin"></div>
        </div>
      );
    }
  }

  return (
    <BrowserRouter>
      <Routes>

        {/* Routes publiques */}
        <Route
          path="/"
          element={
            <CommonCheckAuth user={user} isAuthenticated={isAuthenticated}>
              <AuthLayout />
            </CommonCheckAuth>
          }
        >
          <Route path="/login" element={<AuthLogin />} />
          <Route path="/register" element={<AuthRegister />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>





        {/* Routes privées */}
        <Route
          path="/"
          element={
            <CommonCheckAuth user={user} isAuthenticated={isAuthenticated}>
              <Layout />
            </CommonCheckAuth>
          }
        >
          <Route index element={<PosSystem />} />
          <Route path="/analyse" element={<Accueil />} />
          {/* route Ventes */}
          <Route path="/ventes" element={<Ventes />} />
          {/* route Produits */}
          <Route path="/product" element={<Product />} />
          {/* route Plat */}
          <Route path="/plats" element={<Plat />} />
          {/* route reservation */}
          <Route path="/reservation" element={<Reservation />} />
          {/* route customer */}
          <Route path="/customer" element={<Client />} />
          {/* route invoice */}
          <Route path="/invoice" element={<Invoice />} />
          {/* route settings -> Categorie */}
          <Route path="/categorie" element={<Categorie />} />
          {/* route settings -> users */}
          <Route path="/user" element={<User />} />
          {/* route settings -> table */}
          <Route path="/table" element={<Table />} />
          {/* route settings -> Fournisseur */}
          <Route path="/fournisseur" element={<Fournisseur />} />
          {/* route profil */}
          <Route path="/profil" element={<Profil />} />
          {/* route settings */}
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
